import FontFaceObserver from 'fontfaceobserver';
import { StoreFont } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { fetchFont } from '@/utils/http/fetchFont';
import { getSupportedCharactersOfFont } from '@/model/font/getSupportedCharactersOfFont';
import { getSupportedGlyphsRegExp } from '@/model/font/getSupportedGlyphsRegExp';
import { StoreState, Thunk } from '@/redux/types';
import { SetFontLoadedAction } from '../types';
import { setFontLoadedAction } from './setFontLoadedAction';

const getFontFromState = (
  { core: { fonts: fontFamilies } }: StoreState,
  fontIdentifier: string
) => {
  for (const fontFamily of fontFamilies) {
    for (const font of fontFamily.fonts) {
      if (font.identifier === fontIdentifier) {
        return font;
      }
    }
  }
};

export const ensureFontIsAddedToDocumentAction =
  (font: StoreFont): Thunk<Promise<StoreFont>, SetFontLoadedAction> =>
  async (dispatch, getState) => {
    if (font.supportedGlyphs) {
      return font;
    }

    const fontIdentifier = font.identifier;

    await new FontFaceObserver(fontIdentifier, {
      weight: font.weight,
      style: font.style,
    }).load(null, 8000);

    const fontBuffer = await fetchFont(font.familyId, font.id);
    const supportedCharactersOfFont = getSupportedCharactersOfFont(fontBuffer);
    const supportedGlyphs = getSupportedGlyphsRegExp(supportedCharactersOfFont);
    dispatch(setFontLoadedAction(fontIdentifier, supportedGlyphs));

    return assertDefined(getFontFromState(getState(), fontIdentifier));
  };
